import { InputText } from "primereact/inputtext";
import { classNames } from "primereact/utils";
import { useTranslation } from "react-i18next";
import { Controller, useForm} from 'react-hook-form';
import { Button } from "primereact/button";
import { InputSwitch } from 'primereact/inputswitch';
import { InputTextarea } from "primereact/inputtextarea";
import { Calendar } from "primereact/calendar";
import { InputNumber } from "primereact/inputnumber";
import { useEffect, useState } from "react";
import findFranquia from "../../service/findFranquia";
import findPlano from "../../service/findPlano";
import { SortOrder } from "primereact/api";
import { useGlobalState } from "../../components/globalState/GlobalStateProvider";
import { Dropdown } from "primereact/dropdown";
import { useNavigate } from "react-router";
import patchPlano from "../../service/patchPlano";
import restaurarPlano from "../../service/restaurarPlano";
import findClient from "../../service/findClient";
import { mascaraCNPJ, validarCNPJ, validarCPF } from '../../utils';

export default function ClienteCadastrar({client, onClose, onSave, msgs}:{client:any, onClose: () => void, onSave: (user:any) => void, msgs:any}) {
  const { t } = useTranslation();
  const [inativo, setInativo] = useState(client.inativo ? client.inativo : false);
  const [planos, setPlanos] = useState<any>([]);
  const [selectedScoreQuodVersion, setSelectedScoreQuodVersion] = useState(client.quodScoreVersion);
  const [selectedFranquia, setSelectedFranquia] = useState<any>(null);
  const [franquias, setFranquias] = useState<any>([]);
  const {state} = useGlobalState();
  const [limitarValorMaximo, setLimitarValorMaximo] = useState(client.limitarValorMaximo ? client.limitarValorMaximo : false);
  const [planoSelected, setPlanoSelected] = useState<any>(null);
  const [clienteJaCadastrado, setClienteJaCadastrado] = useState(false);
  const [addressData, setAddressData] = useState({
    logradouro: client.logradouro || '',
    bairro: client.bairro || '',
    cidade: client.cidade || '',
    uf: client.uf || ''
  });
  const navigate = useNavigate();
  const scoreQuodVersions = [
      { name: 'Selecione', code: null },
      { name: 'SCORE 5.0', code: 'SCORE_5' },
      { name: 'SCORE 3.0', code: 'SCORE_3' }
  ];
  const defaultValues = {
    nome: '',
    email: '',
    documento:'',
    responsavel: '',
    telefone:'',
    valorMaximo: null,
    plano: null,
    whatsapp:'',
    observacoes: '',
    codigoClienteErp: '',
    tempoCacheConsulta: null,
    nomeFantasia: '',
    cep: '',
    logradouro: '',
    numeroEndereco: '',
    complemento: '',
    bairro: '',
    cidade: '',
    uf: '',
    dataCadastro: client.dataCadastro ? new Date(client.dataCadastro) : null,
    dataContratacao: client.dataContratacao ? new Date(client.dataContratacao) : null,
    diaVencimentoFatura: '',
    vcm: 0.00,
    cnae: ''
  };
  defaultValues.nome = client.nome ? client.nome.toString() : ''
  defaultValues.email = client.email ? client.email.toString() : ''
  defaultValues.documento = client.documento ? client.documento.toString() : ''
  defaultValues.responsavel = client.responsavel ? client.responsavel.toString() : ''
  defaultValues.telefone = client.telefone ? client.telefone.toString() : ''
  defaultValues.whatsapp = client.whatsapp ? client.whatsapp.toString() : ''
  defaultValues.tempoCacheConsulta = client.tempoCacheConsulta ? client.tempoCacheConsulta : null
  defaultValues.observacoes = client.observacoes ? client.observacoes.toString() : ''
  defaultValues.codigoClienteErp = client.codigoClienteErp ? client.codigoClienteErp.toString() : ''
  defaultValues.nomeFantasia = client.nomeFantasia ? client.nomeFantasia.toString() : ''
  defaultValues.cep = client.cep ? client.cep.toString() : ''
  defaultValues.logradouro = client.logradouro ? client.logradouro.toString() : ''
  defaultValues.numeroEndereco = client.numeroEndereco ? client.numeroEndereco.toString() : ''
  defaultValues.complemento = client.complemento ? client.complemento.toString() : ''
  defaultValues.bairro = client.bairro ? client.bairro.toString() : ''
  defaultValues.cidade = client.cidade ? client.cidade.toString() : ''
  defaultValues.uf = client.uf ? client.uf.toString() : ''
  defaultValues.dataCadastro = client.dataCadastro ? new Date(client.dataCadastro) : null
  defaultValues.dataContratacao = client.dataContratacao ? new Date(client.dataContratacao) : null
  defaultValues.diaVencimentoFatura = client.diaVencimentoFatura ? client.diaVencimentoFatura.toString() : ''
  defaultValues.vcm = client.vcm ? client.vcm : 0.00
  defaultValues.valorMaximo = client.valorMaximo ? client.valorMaximo : 0.00
  defaultValues.cnae = client.cnae ? client.cnae.toString() : ''

const editarPlano = () => {
  navigate(`/plano/`,{state:{plano:planoSelected}});
}

const customizarPlano = () => {
  patchPlano(planoSelected.id, client.id)
  .then((data:any) => {
    data.planosServico.forEach((ps:any) => {
      ps.planosServicoValor.forEach((psv:any) => {
        psv.data = new Date(psv.data)
      });
    });
    navigate(`/plano/`,{state:{plano:data}});
  })
}

const restaurarPlanoCustomizado = () => {
  restaurarPlano(planoSelected.id, client.id, planoSelected.idOrigem)
  .then(() => {
    onClose();
  })
}

  const {
      control,
      formState: { errors},
      handleSubmit,
      setValue
  } = useForm({ defaultValues });

const preencherDadosCliente = (clienteEncontrado: any) => {
    setValue('nome', clienteEncontrado.nome || '');
    setValue('email', clienteEncontrado.email || '');
    setValue('responsavel', clienteEncontrado.responsavel || '');
    setValue('telefone', clienteEncontrado.telefone || '');
    setValue('whatsapp', clienteEncontrado.whatsapp || '');
    setValue('observacoes', clienteEncontrado.observacoes || '');
    setValue('codigoClienteErp', clienteEncontrado.codigoClienteErp || '');
    setValue('nomeFantasia', clienteEncontrado.nomeFantasia || '');
    setValue('cep', clienteEncontrado.cep || '');
    setValue('logradouro', clienteEncontrado.logradouro || '');
    setValue('numeroEndereco', clienteEncontrado.numeroEndereco || '');
    setValue('complemento', clienteEncontrado.complemento || '');
    setValue('bairro', clienteEncontrado.bairro || '');
    setValue('cidade', clienteEncontrado.cidade || '');
    setValue('uf', clienteEncontrado.uf || '');
    setValue('cnae', clienteEncontrado.cnae || '');
    setValue('valorMaximo', clienteEncontrado.valorMaximo || 0);
    setValue('vcm', clienteEncontrado.vcm || 0);
    setValue('diaVencimentoFatura', clienteEncontrado.diaVencimentoFatura || '');
    setValue('tempoCacheConsulta', clienteEncontrado.tempoCacheConsulta || null);
    if (clienteEncontrado.dataCadastro) setValue('dataCadastro', new Date(clienteEncontrado.dataCadastro));
    if (clienteEncontrado.dataContratacao) setValue('dataContratacao', new Date(clienteEncontrado.dataContratacao));

    setInativo(clienteEncontrado.inativo || false);
    setLimitarValorMaximo(clienteEncontrado.limitarValorMaximo || false);

    if (clienteEncontrado.idPlano) {
      const plano = planos.find((p: any) => p.id === clienteEncontrado.idPlano || p.descricao === clienteEncontrado.nomePlano);
      if (plano) { setValue('plano', plano); setPlanoSelected(plano); }
    }
    if (clienteEncontrado.idFranquia) {
      const franquia = franquias.find((f: any) => f.id === clienteEncontrado.idFranquia || f.nome === clienteEncontrado.nomeFranquia);
      if (franquia) setSelectedFranquia(franquia);
    }

    if (clienteEncontrado.logradouro || clienteEncontrado.bairro || clienteEncontrado.cidade || clienteEncontrado.uf) {
      setAddressData({
        logradouro: clienteEncontrado.logradouro || '',
        bairro: clienteEncontrado.bairro || '',
        cidade: clienteEncontrado.cidade || '',
        uf: clienteEncontrado.uf || ''
      });
    }
  }

  const verificarClienteExistente = (documento: string) => {
    findClient({
      first: 0,
      rows: 1,
      page: 1,
      cliente: null,
      documento: documento,
      idFranquia: null,
      inativo: null,
      sortField: 'nome',
      sortOrder: SortOrder.DESC
    }).then((data) => {
      if (data.clientes && data.clientes.length > 0) {
        const clienteEncontrado = data.clientes[0];
        setClienteJaCadastrado(true);
        preencherDadosCliente(clienteEncontrado);
        msgs.current?.clear();
        msgs.current?.show([{
          sticky: true,
          severity: 'warn',
          summary: 'Cliente já cadastrado',
          detail: `O cliente "${clienteEncontrado.nome}" já está cadastrado com este documento. Não é possível prosseguir com o cadastro.`,
          closable: true
        }]);
      } else {
        setClienteJaCadastrado(false);
      }
    }).catch(() => {
      setClienteJaCadastrado(false);
    });
  }

  const validDocument = (document: string) => {
    const cleanDoc = document.replace(/[^A-Z0-9]/gi, '');
    const valid = cleanDoc.length === 11 ? validarCPF(document) : validarCNPJ(document);
    if (valid) {
      msgs.current?.clear();
      if (!client.id) {
        verificarClienteExistente(cleanDoc);
      }
    } else {
      msgs.current?.clear();
      msgs.current?.show([
        { sticky: false, life: 10000, severity: 'error', summary: 'Erro', detail: 'Documento inválido', closable: false }
      ]);
    }
  }

  const onSubmit = (data:any) => {
      data.nome && save(data);
  };

 
  const save = (data:any) => {
    const cliente = {
      id: client.id? client.id : undefined,
      nome:data.nome,
      documento:data.documento.replaceAll('.','').replaceAll('-','').replaceAll('/',''),
      email:data.email,
      responsavel:data.responsavel,
      telefone:data.telefone,
      whatsapp:data.whatsapp,
      quodScoreVersion: selectedScoreQuodVersion,
      observacoes: data.observacoes,
      valorMaximo: data.valorMaximo,
      limitarValorMaximo: limitarValorMaximo,
      inativo:inativo,
      tempoCacheConsulta: data.tempoCacheConsulta,
      idPlano: data.plano ? data.plano.id : null,
      codigoClienteErp:data.codigoClienteErp,
      nomeFantasia:data.nomeFantasia,
      cep:data.cep,
      logradouro:data.logradouro,
      numeroEndereco:data.numeroEndereco,
      complemento:data.complemento,
      bairro:data.bairro,
      cidade:data.cidade,
      uf:data.uf,
      dataCadastro:data.dataCadastro,
      dataContratacao:data.dataContratacao,
      diaVencimentoFatura:data.diaVencimentoFatura,
      vcm:data.vcm === 0 ? null : data.vcm,
      cnae:data.cnae,
      idFranquia: selectedFranquia?.id
    }
    window.scrollTo(0, 0);
    onSave(cliente);
  }
  
  const getFormErrorMessage = (name:string) => {
    type ObjectKey = keyof typeof errors;
    const error = errors[Object.keys(errors).find(k => k === name) as ObjectKey]
    return error ? <small className="p-error">{error.message}</small> : <small className="p-error">&nbsp;</small>;
  };

  const fetchAddress = async (cep: string) => {
    try {
      const response = await fetch(`https://viacep.com.br/ws/${cep}/json/`);
      const data = await response.json();
      if (!data.erro) {
        setAddressData(prevData => ({
          ...prevData,
          logradouro: data.logradouro,
          bairro: data.bairro,
          cidade: data.localidade,
          uf: data.uf
        }));
      } else {
        msgs.current?.show({
          sticky: false,
          life: 10000,
          severity: 'error',
          summary: 'Erro',
          detail: 'CEP não encontrado',
          closable: false
        });
      }
    } catch (error) {
      console.error('Error fetching address:', error);
    }
  };

  useEffect(() => {
    const lazyFranquia = {
        first: 0,
        rows: 9999,
        page: 1,
        franquia: null,
        documento: null,
        sortField: 'nome',
        sortOrder: SortOrder.DESC
      };
     
      findFranquia(lazyFranquia).then(data => {
        data.franquias.forEach( (c: { nome: string; id: string; }) => {
          if(client.id && client.idFranquia && c.nome == client.nomeFranquia){
            setSelectedFranquia(c)
          }
         
          if(state.user.franquiaSelected && c.nome == state.user.franquiaSelected.nome){
            setSelectedFranquia(c)
          }
        })
        setFranquias(data.franquias);
      })
    const lazyPlano = {
        first: 0,
        rows: 99999999,
        page: 1,
        descricao: null,
        idFranquia : state.user.franquiaSelected?.id ? state.user.franquiaSelected?.id : null,
        sortField: 'descricao',
        sortOrder: SortOrder.DESC
      }
      findPlano(lazyPlano).then((data) => {
        setPlanos(data.planos);
        if(client.idPlano){
            setValue('plano',data.planos.filter((s:any) => s.descricao === client.nomePlano)[0]);
            setPlanoSelected(data.planos.filter((s:any) => s.descricao === client.nomePlano)[0])
        }
        
      });
      if(client.valorMaximo){
        setValue('valorMaximo',client.valorMaximo.replaceAll('.', '').replaceAll(',', '.'));
      }
  },[])

  return (
    <form onSubmit={handleSubmit(onSubmit)} className="flex flex-column gap-2">
        <div>
          <div className="grid">
              <div className="col p-fluid flex flex-wrap">
                
                  <Controller
                      name="nome"
                      control={control}
                      rules={{ required: 'Nome é Obrigatório' }}
                      render={({ field, fieldState }) => (
                          <>
                              <label htmlFor={field.name} className={classNames({ 'p-error': errors.nome })}></label>
                              <span className="">
                              <div>
                                <label htmlFor="nome" className="font-bold block mb-2 required">{t('razaoSocial')} </label>
                                <InputText style={{width:'100%'}} id={field.name} value={field.value} className={classNames({ 'p-invalid': fieldState.error })} onChange={(e) => field.onChange(e.target.value)} />
                                </div>
                              </span>
                              {getFormErrorMessage(field.name)}
                          </>
                      )}
                  />
                    
               
              </div>
              <div className="col">
                <Controller
                      name="documento"
                      control={control}
                      rules={{ required: 'Documento é Obrigatório' }}
                      render={({ field, fieldState }) => (
                          <>
                              <label htmlFor={field.name} className={classNames({ 'p-error': errors.documento })}></label>
                              <span className="">
                              <div>
                                  <label htmlFor="documento" className="font-bold block mb-2 required">{t('cnpj')} </label>
                                  <InputText maxLength={18} min={18} max={18} onKeyUp={() => { field.onChange(mascaraCNPJ(field.value))}} style={{width:'100%'}} id={field.name} value={field.value} className={classNames({ 'p-invalid': fieldState.error })} onBlur={(e) => validDocument(e.target.value)} onChange={(e) => { field.onChange(e.target.value); if (clienteJaCadastrado) setClienteJaCadastrado(false); }} disabled={!!(client.id)} />
                              </div>
                              </span>
                              {getFormErrorMessage(field.name)}
                          </>
                      )}
                  />
               
              </div>
          </div>
          <div className="grid">
            <div className="col p-fluid flex flex-wrap">
              <Controller
                      name="telefone"
                      control={control}
                      render={({ field, fieldState }) => (
                          <>
                              <label htmlFor={field.name} className={classNames({ 'p-error': errors.telefone })}></label>
                              <span className="">
                              <div>
                                  <label htmlFor="telefone" className="font-bold block mb-2">{t('fone')} </label>
                                  <InputText style={{width:'100%'}} id={field.name} value={field.value} className={classNames({ 'p-invalid': fieldState.error })} onChange={(e) => field.onChange(e.target.value)} />
                              </div>
                              </span>
                              {getFormErrorMessage(field.name)}
                          </>
                      )}
                  />
            </div>
            <div className="col">
                <Controller
                      name="whatsapp"
                      control={control}
                      
                      render={({ field, fieldState }) => (
                          <>
                              <label htmlFor={field.name} className={classNames({ 'p-error': errors.whatsapp })}></label>
                              <span className="">
                              <div>
                                  <label htmlFor="whatsapp" className="font-bold block mb-2">{t('whatsapp')} </label>
                                  <InputText style={{width:'100%'}} id={field.name} value={field.value} className={classNames({ 'p-invalid': fieldState.error })} onChange={(e) => field.onChange(e.target.value)} />
                              </div>
                              </span>
                              {getFormErrorMessage(field.name)}
                          </>
                      )}
                  />
               
              </div>
          </div>
          <div className="grid">
            <div className="col p-fluid flex flex-wrap">
              <Controller
                      name="email"
                      control={control}
                      rules={{ required: 'Email é Obrigatório' }}
                      render={({ field, fieldState }) => (
                          <>
                              <label htmlFor={field.name} className={classNames({ 'p-error': errors.documento })}></label>
                              <span className="">
                              <div>
                                  <label htmlFor="email" className="font-bold block mb-2 required">{t('email')} </label>
                                  <InputText style={{width:'100%'}} id={field.name} value={field.value} className={classNames({ 'p-invalid': fieldState.error })} onChange={(e) => field.onChange(e.target.value)} />
                              </div>
                              </span>
                              {getFormErrorMessage(field.name)}
                          </>
                      )}
                  />
            </div>
            <div className="col">
                <Controller
                      name="responsavel"
                      control={control}
                      
                      render={({ field, fieldState }) => (
                          <>
                              <label htmlFor={field.name} className={classNames({ 'p-error': errors.responsavel })}></label>
                              <span className="">
                              <div>
                                  <label htmlFor="responsavel" className="font-bold block mb-2">{t('responsavel')} </label>
                                  <InputText style={{width:'100%'}} id={field.name} value={field.value} className={classNames({ 'p-invalid': fieldState.error })} onChange={(e) => field.onChange(e.target.value)} />
                              </div>
                              </span>
                              {getFormErrorMessage(field.name)}
                          </>
                      )}
                  />
               
              </div>
          </div>
          <div className="grid">
            
            <div className="col p-fluid flex flex-wrap">
               
               <div className="grid">
            
                <div className="col">
                <Controller
                      name="plano"
                      control={control}
                      rules={{ required: 'Plano é Obrigatório' }}
                      render={({ field, fieldState }) => (
                          <>
                              <label htmlFor={field.name} className={classNames({ 'p-error': errors.plano })}></label>
                              <span className="">
                              <div>
                                  <label htmlFor="plano" className="font-bold block mb-2 required">{t('plano')} </label>
                                  <Dropdown style={{width: '100%'}} value={field.value}  onChange={(e) => field.onChange(e.value)} options={planos} optionLabel="descricao" placeholder="Selecione Plano" 
                                  filter className="md:w-14rem" /> 
                              </div>
                              </span>
                              {getFormErrorMessage(field.name)}
                          </>
                      )}
                  />
                </div>
                <div className="col" style={{display: 'inline-grid'}}>
                  {state.user.funcoes.includes("PLANO_CADASTRAR") && planoSelected && (<Button type="button" style={{width: '12rem', color:'#183462'}} onClick={()=>editarPlano()} icon="pi pi-pen-to-square" label="Editar Plano" text />)}
                  {state.user.funcoes.includes("PLANO_CADASTRAR") && client.id && client.idPlano && planoSelected && !planoSelected.idOrigem  && (<Button type="button" style={{width: '12rem', color:'#183462'}} onClick={()=>customizarPlano()} icon="pi pi-clone" label="Customizar Plano" text />)}
                  {state.user.funcoes.includes("PLANO_CADASTRAR") && client.id && client.idPlano && planoSelected && planoSelected.idOrigem  && (<Button type="button" style={{width: '12rem', color:'#183462'}} onClick={()=>restaurarPlanoCustomizado()} icon="pi pi-directions-alt" label="Restaurar Plano" text />)}
                </div>
                </div>
               
              </div>
            </div>
            <div className="grid">          
              <div className="col">
              <Controller
                name="vcm"
                control={control}
                render={({ field, fieldState }) => (
                  <>
                    <label htmlFor={field.name} className={classNames({ 'p-error': errors.vcm })}></label>
                    <span className="">
                      <div>
                        <label htmlFor={field.name} className="font-bold block mb-2">{t('vcm')} </label>
                        <InputNumber
                          style={{ width: '100%' }}
                          id={field.name}
                          value={field.value}
                          className={classNames({ 'p-invalid': fieldState.error })}
                          onValueChange={(e) => field.onChange(e.value)}
                          mode="currency"
                          currency="BRL"
                          locale="pt-BR"
                        />
                      </div>
                    </span>
                    {getFormErrorMessage(field.name)}
                  </>
                )}
              />
            </div>
            <div className="col p-fluid flex flex-wrap">
                <div >
                    <label className="label-dados" style={{paddingLeft:'0'}}>{t('limitarValorMaximo')}</label>
                    <div style={{width:'100%'}}>
                      <InputSwitch checked={limitarValorMaximo} value={limitarValorMaximo} onChange={() => setLimitarValorMaximo(!limitarValorMaximo)} />
                    </div>
                </div>
              </div>
              {limitarValorMaximo && (
              <div className="col">
                <Controller
                      name="valorMaximo"
                      control={control}
                      rules={{ required: 'Valor Máximo é Obrigatório' }}
                      render={({ field, fieldState }) => (
                          <>
                              <label htmlFor={field.name} className={classNames({ 'p-error': errors.valorMaximo })}></label>
                              <span className="">
                              <div>
                                  <label htmlFor="valorMaximo" className="font-bold block mb-2">{t('valorMaximo')} </label>
                                  <InputNumber id={field.name} value={field.value} className={classNames({ 'p-invalid': fieldState.error })} onChange={(e) => field.onChange(e.value)} mode="currency" currency="BRL" locale="pt-BR" />
                              </div>
                              </span>
                              {getFormErrorMessage(field.name)}
                          </>
                      )}
                  />
              </div>)}
            </div>
          <div className="grid">
            <div className="col">
              <div>
                  <label className="label-dados" style={{paddingLeft:'0'}}>{t('scoreQuodVersion')}</label>
                  <Dropdown style={{width: '50%'}} value={selectedScoreQuodVersion} onChange={(e) => setSelectedScoreQuodVersion(e.value)} options={scoreQuodVersions} optionLabel="name" 
                      placeholder="Selecione" optionValue='code' className="w-full md:w-14rem" />
              </div>
              <div className="col">
                <Controller
                      name="tempoCacheConsulta"
                      control={control}
                      
                      render={({ field, fieldState }) => (
                          <>
                              <label htmlFor={field.name} className={classNames({ 'p-error': errors.tempoCacheConsulta })}></label>
                              <span className="">
                              <div>
                                  <label htmlFor="tempoCacheConsulta" className="font-bold block mb-2">{t('tempoCacheConsulta')} </label>
                                  <InputNumber value={field.value} onChange={(e) => field.onChange(e.value)} useGrouping={false}  />
                              </div>
                              </span>
                              {getFormErrorMessage(field.name)}
                          </>
                      )}
                  />
            
              </div>
            </div>
              <div className="col p-fluid flex flex-wrap">
                {!state.user.franquia && (
                  <div>
                    <label className="label-dados" style={{paddingLeft:'0'}}>{t('franquia')}</label>
                    <Dropdown disabled ={state.user.franquiaSelected} style={{width: '50%'}} value={selectedFranquia} onChange={(e) => setSelectedFranquia(e.value)} options={franquias} optionLabel="nome" 
                        placeholder="Selecione" className="w-full md:w-14rem" />
                  </div>
                )}
              </div>
          </div>
          <div className="grid">
            
            <div className="col">
                <Controller
                      name="observacoes"
                      control={control}
                      
                      render={({ field, fieldState }) => (
                          <>
                              <label htmlFor={field.name} className={classNames({ 'p-error': errors.whatsapp })}></label>
                              <span className="">
                              <div>
                                  <label htmlFor="observacoes" className="font-bold block mb-2">{t('observacoes')} </label>
                                  <InputTextarea style={{width:'100%'}} id={field.name} value={field.value} className={classNames({ 'p-invalid': fieldState.error })} onChange={(e) => field.onChange(e.target.value)} />
                              </div>
                              </span>
                              {getFormErrorMessage(field.name)}
                          </>
                      )}
                  />
               
              </div>
          </div>
        <div className="grid">
            <div className="col p-fluid flex flex-wrap">
              <Controller
                      name="codigoClienteErp"
                      control={control}
                      render={({ field, fieldState }) => (
                          <>
                              <label htmlFor={field.name} className={classNames({ 'p-error': errors.codigoClienteErp })}></label>
                              <span className="">
                              <div>
                                  <label htmlFor="codigoCliente" className="font-bold block mb-2">{t('codigoCliente')} </label>
                                  <InputText style={{width:'100%'}} id={field.name} value={field.value} className={classNames({ 'p-invalid': fieldState.error })} onChange={(e) => field.onChange(e.target.value)} />
                              </div>
                              </span>
                              {getFormErrorMessage(field.name)}
                          </>
                      )}
                  />
            </div>
            <div className="col">
                <Controller
                      name="nomeFantasia"
                      control={control}
                      render={({ field, fieldState }) => (
                          <>
                              <label htmlFor={field.name} className={classNames({ 'p-error': errors.nomeFantasia })}></label>
                              <span className="">
                              <div>
                                  <label htmlFor="nomeFantasia" className="font-bold block mb-2">{t('nomeFantasia')} </label>
                                  <InputText style={{width:'100%'}} id={field.name} value={field.value} className={classNames({ 'p-invalid': fieldState.error })} onChange={(e) => field.onChange(e.target.value)} />
                              </div>
                              </span>
                              {getFormErrorMessage(field.name)}
                          </>
                      )}
                  />
            </div>
            <div className="col p-fluid flex flex-wrap">
              <div >
                  <label className="label-dados" style={{paddingLeft:'0'}}>{t('inativo')}</label>
                  <div style={{width:'100%' , marginTop:'0.5rem'}}>
                    <InputSwitch checked={inativo} value={inativo} onChange={() => setInativo(!inativo)} />
                  </div>
              </div>
            </div>
          </div>
          <div className="grid">
            <div className="col">
              <Controller
                name="cep"
                control={control}
                render={({ field, fieldState }) => (
                  <>
                    <label htmlFor={field.name} className={classNames({ 'p-error': errors.cep })}></label>
                    <span className="">
                      <div>
                        <label htmlFor="cep" className="font-bold block mb-2">{t('cep')} </label>
                        <InputText
                          style={{ width: '100%' }}
                          id={field.name}
                          value={field.value}
                          className={classNames({ 'p-invalid': fieldState.error })}
                          onChange={(e) => {
                            field.onChange(e.target.value);
                            fetchAddress(e.target.value);
                          }}
                          onKeyPress={(e) => { if (!/[0-9]/.test(e.key)) {e.preventDefault();}}}
                          maxLength={8}
                        />
                      </div>
                    </span>
                    {getFormErrorMessage(field.name)}
                  </>
                )}
              />
            </div>
            <div className="col">
              <Controller
                name="logradouro"
                control={control}
                render={({ field, fieldState }) => (
                  <>
                    <label htmlFor={field.name} className={classNames({ 'p-error': errors.logradouro })}></label>
                    <span className="">
                      <div>
                        <label htmlFor="logradouro" className="font-bold block mb-2">{t('logradouro')} </label>
                        <InputText
                          style={{ width: '100%' }}
                          id={field.name}
                          value={addressData.logradouro}
                          className={classNames({ 'p-invalid': fieldState.error })}
                          onChange={(e) => {
                            field.onChange(e.target.value);
                            setAddressData(prevData => ({ ...prevData, logradouro: e.target.value }));
                          }}
                        />
                      </div>
                    </span>
                    {getFormErrorMessage(field.name)}
                  </>
                )}
              />
            </div>
            <div className="col">
              <Controller
                name="numeroEndereco"
                control={control}
                render={({ field, fieldState }) => (
                  <>
                    <label htmlFor={field.name} className={classNames({ 'p-error': errors.numeroEndereco })}></label>
                    <span className="">
                      <div>
                        <label htmlFor="numero" className="font-bold block mb-2">{t('numero')} </label>
                        <InputText
                          style={{ width: '100%' }}
                          id={field.name}
                          value={field.value}
                          className={classNames({ 'p-invalid': fieldState.error })}
                          onChange={(e) => field.onChange(e.target.value)}
                        />
                      </div>
                    </span>
                    {getFormErrorMessage(field.name)}
                  </>
                )}
              />
            </div>
            <div className="col">
              <Controller
                name="bairro"
                control={control}
                render={({ field, fieldState }) => (
                  <>
                    <label htmlFor={field.name} className={classNames({ 'p-error': errors.bairro })}></label>
                    <span className="">
                      <div>
                        <label htmlFor="bairro" className="font-bold block mb-2">{t('bairro')} </label>
                        <InputText
                          style={{ width: '100%' }}
                          id={field.name}
                          value={addressData.bairro}
                          className={classNames({ 'p-invalid': fieldState.error })}
                          onChange={(e) => {
                            field.onChange(e.target.value);
                            setAddressData(prevData => ({ ...prevData, bairro: e.target.value }));
                          }}
                        />
                      </div>
                    </span>
                    {getFormErrorMessage(field.name)}
                  </>
                )}
              />
            </div>
          </div>
          <div className="grid">
            <div className="col p-fluid flex flex-wrap">
                  <Controller
                        name="complemento"
                        control={control}
                        render={({ field, fieldState }) => (
                            <>
                                <label htmlFor={field.name} className={classNames({ 'p-error': errors.complemento })}></label>
                                <span className="">
                                <div>
                                    <label htmlFor="complemento" className="font-bold block mb-2">{t('complemento')} </label>
                                    <InputText style={{width:'100%'}} id={field.name} value={field.value} className={classNames({ 'p-invalid': fieldState.error })} onChange={(e) => field.onChange(e.target.value)} />
                                </div>
                                </span>
                                {getFormErrorMessage(field.name)}
                            </>
                        )}
                    />
            </div>
            <div className="col">
              <Controller
                name="cidade"
                control={control}
                render={({ field, fieldState }) => (
                  <>
                    <label htmlFor={field.name} className={classNames({ 'p-error': errors.cidade })}></label>
                    <span className="">
                      <div>
                        <label htmlFor="cidade" className="font-bold block mb-2">{t('cidade')} </label>
                        <InputText
                          style={{ width: '100%' }}
                          id={field.name}
                          disabled={true}
                          value={addressData.cidade}
                          className={classNames({ 'p-invalid': fieldState.error })}
                          onChange={(e) => {
                            field.onChange(e.target.value);
                            setAddressData(prevData => ({ ...prevData, cidade: e.target.value }));
                          }}
                        />
                      </div>
                    </span>
                    {getFormErrorMessage(field.name)}
                  </>
                )}
              />
            </div>
            <div className="col">
              <Controller
                name="uf"
                control={control}
                render={({ field, fieldState }) => (
                  <>
                    <label htmlFor={field.name} className={classNames({ 'p-error': errors.uf })}></label>
                    <span className="">
                      <div>
                        <label htmlFor="uf" className="font-bold block mb-2">{t('uf')} </label>
                        <InputText
                          style={{ width: '100%' }}
                          disabled={true}
                          id={field.name}
                          value={addressData.uf}
                          className={classNames({ 'p-invalid': fieldState.error })}
                          onChange={(e) => {
                            field.onChange(e.target.value);
                            setAddressData(prevData => ({ ...prevData, uf: e.target.value }));
                          }}
                        />
                      </div>
                    </span>
                    {getFormErrorMessage(field.name)}
                  </>
                )}
              />
            </div>
          </div>
          <div className="grid">
            <div className="col p-fluid flex flex-wrap">
                <Controller
                      name="dataCadastro"
                      control={control}
                      render={({ field, fieldState }) => (
                          <>
                              <label htmlFor={field.name} className={classNames({ 'p-error': errors.dataCadastro })}></label>
                              <span className="">
                              <div>
                                  <label htmlFor="dataCadastro" className="font-bold block mb-2">{t('dataCadastro')} </label>
                                  <Calendar id='dataCadastro' value={field.value || null}  onChange={(e) => field.onChange(e.target.value)} showIcon dateFormat="dd/mm/yy" locale='pt'/>
                              </div>
                              </span>
                              {getFormErrorMessage(field.name)}
                          </>
                      )}
                  />
            </div>
            <div className="col p-fluid flex flex-wrap">
              <Controller
                      name="dataContratacao"
                      control={control}
                      render={({ field, fieldState }) => (
                          <>
                              <label htmlFor={field.name} className={classNames({ 'p-error': errors.dataContratacao })}></label>
                              <span className="">
                              <div>
                                  <label htmlFor="dataContratacao" className="font-bold block mb-2">{t('dataContratacao')} </label>
                                  <Calendar id='dataContratacao' value={field.value || null}  onChange={(e) => field.onChange(e.target.value)} showIcon dateFormat="dd/mm/yy" locale='pt'/>
                              </div>
                              </span>
                              {getFormErrorMessage(field.name)}
                          </>
                      )}
                  />
            </div>
            <div className="col">
                <Controller
                      name="diaVencimentoFatura"
                      control={control}
                      render={({ field, fieldState }) => (
                          <>
                              <label htmlFor={field.name} className={classNames({ 'p-error': errors.diaVencimentoFatura })}></label>
                              <span className="">
                              <div>
                                  <label htmlFor="diaVencimentoFatura" className="font-bold block mb-2">{t('diaVencimentoFatura')} </label>
                                  <InputText maxLength={2} style={{width:'100%'}} id={field.name} value={field.value} className={classNames({ 'p-invalid': fieldState.error })} onChange={(e) => field.onChange(e.target.value)} onKeyPress={(e) => { if (!/[0-9]/.test(e.key)) {e.preventDefault();}}} />
                              </div>
                              </span>
                              {getFormErrorMessage(field.name)}
                          </>
                      )}
                  />
            </div>
            <div className="col">
                <Controller
                      name="cnae"
                      control={control}
                      render={({ field, fieldState }) => (
                          <>
                              <label htmlFor={field.name} className={classNames({ 'p-error': errors.cnae })}></label>
                              <span className="">
                              <div>
                                  <label htmlFor="cnae" className="font-bold block mb-2">{t('cnae')} </label>
                                  <InputText style={{width:'100%'}} id={field.name} value={field.value} className={classNames({ 'p-invalid': fieldState.error })} onChange={(e) => field.onChange(e.target.value)} />
                              </div>
                              </span>
                              {getFormErrorMessage(field.name)}
                          </>
                      )}
                  />
            </div>
          </div>
        </div>
        <br></br>
        <br></br>
        <div style={{display:"flex", justifyContent:"flex-end", paddingTop:"1rem"}} className=" flex">
            <Button style={{marginRight:"1rem", backgroundColor:'#183462'}} label="Salvar" type="submit" disabled={clienteJaCadastrado} />
            <Button icon="pi pi-times" onClick={onClose} rounded outlined severity="danger" aria-label="Cancel" />
        </div> 
    </form>
    
  )
}

